import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
    providedIn: 'root',
})

export class IconHelper {

    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer){
        // icons
        this.matIconRegistry.addSvgIcon(
          "bagger",
          this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/bagger.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "bagger_alarm",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/bagger_alarm.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "engine_alarm",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/engine_alarm.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "boomAngleIcon",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/boomAngleIcon.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "joystick",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/joystick.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "MachineHours",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/MachineHours.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "pressure",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/HydraulicPressure.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "close_menu",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/close_menu.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "pin",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/pin.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "feedback",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/feedback.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "pos_pres",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/position_pressure.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "drive",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/drive_multi.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "break",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/break.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "account",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/account.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "question",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../assets/icons/Question.svg")
        );
      }

    
}